
// // frontend/src/pages/StudentSubmissions.js
// import React, { useState, useEffect, useContext } from 'react';
// import {
//   Container,
//   Typography,
//   Box,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Button,
//   CircularProgress,
//   Snackbar,
//   Alert,
// } from '@mui/material';
// import axios from 'axios';
// import { AuthContext } from '../contexts/AuthContext';

// const StudentSubmissions = () => {
//   const { token } = useContext(AuthContext);
//   const [submissions, setSubmissions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

//   useEffect(() => {
//     const fetchSubmissions = async () => {
//       if (!token) return;
//       setLoading(true);
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/assignments/mysubmissions`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setSubmissions(res.data);
//       } catch (error) {
//         console.error('Error fetching submissions:', error);
//         setSnackbar({ open: true, message: 'Failed to load submissions.', severity: 'error' });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSubmissions();
//   }, [token]);

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)',
//         py: 4,
//       }}
//     >
//       <Container maxWidth="md">
//         <Box
//           sx={{
//             p: 3,
//             bgcolor: 'background.paper',
//             borderRadius: 2,
//             boxShadow: 3,
//             background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
//           }}
//         >
//           <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main', mb: 2 }}>
//             My Submissions
//           </Typography>

//           {loading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
//               <CircularProgress />
//             </Box>
//           ) : submissions.length === 0 ? (
//             <Typography variant="body1" sx={{ textAlign: 'center', color: 'text.secondary' }}>
//               You have not submitted any assignments yet.
//             </Typography>
//           ) : (
//             <Table>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Assignment</TableCell>
//                   <TableCell>Due Date</TableCell>
//                   <TableCell>Submission File</TableCell>
//                   <TableCell>Grade</TableCell>
//                   <TableCell>Feedback</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {submissions.map((sub) => (
//                   <TableRow key={sub._id}>
//                     <TableCell>{sub.assignmentId?.title || 'Deleted Assignment'}</TableCell>
//                     <TableCell>
//                       {sub.assignmentId ? new Date(sub.assignmentId.dueDate).toLocaleDateString() : '-'}
//                     </TableCell>
//                     <TableCell>
//                       {sub.fileUrl ? (
//                         <Button
//                           variant="outlined"
//                           size="small"
//                           onClick={() => window.open(sub.fileUrl, '_blank')}
//                         >
//                           View File
//                         </Button>
//                       ) : (
//                         '-'
//                       )}
//                     </TableCell>
//                     <TableCell>{sub.letterGrade || '-'}</TableCell>
//                     <TableCell>{sub.feedback || '-'}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           )}
//         </Box>
//       </Container>

//       {/* Snackbar Notification */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default StudentSubmissions;



// frontend/src/pages/StudentSubmissions.js
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';

const StudentSubmissions = () => {
  const { token } = useContext(AuthContext);
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  useEffect(() => {
    const fetchSubmissions = async () => {
      if (!token) return;
      setLoading(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/assignments/mysubmissions`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSubmissions(res.data);
      } catch (error) {
        console.error('Error fetching submissions:', error);
        setSnackbar({ open: true, message: 'Failed to load submissions.', severity: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchSubmissions();
  }, [token]);

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getGradeColor = (grade) => {
    if (!grade) return '#6b7280';
    const gradeValue = grade.charAt(0);
    switch (gradeValue) {
      case 'A': return '#10b981';
      case 'B': return '#3b82f6';
      case 'C': return '#f59e0b';
      case 'D': return '#f97316';
      case 'F': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getStatusBadge = (submission) => {
    if (submission.letterGrade) {
      return { text: 'Graded', color: '#10b981', bg: 'rgba(16, 185, 129, 0.1)' };
    }
    return { text: 'Pending', color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)' };
  };

  return (
    <div className="submissions-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .submissions-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .submissions-container::before {
          content: '';
          position: absolute;
          top: 10%;
          right: 15%;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 4s ease-in-out infinite;
        }

        .submissions-container::after {
          content: '';
          position: absolute;
          bottom: 25%;
          left: 8%;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 3.5s ease-in-out infinite;
          animation-delay: 1.8s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-12px) rotate(6deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes slideInFromBottom {
          from { 
            opacity: 0; 
            transform: translateY(100px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }

        .pulse-element {
          position: absolute;
          top: 40%;
          right: 25%;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.06);
          animation: pulse 3s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 0.7; }
        }

        .submissions-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .header-section {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(10px);
        }

        .main-title {
          font-size: clamp(2.2rem, 4vw, 3rem);
          font-weight: 900;
          color: white;
          margin-bottom: 0.5rem;
          text-shadow: 0 4px 20px rgba(0,0,0,0.3);
          animation: slideIn 0.8s ease-out;
        }

        .gradient-text {
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 300;
          font-size: 1rem;
          animation: slideIn 0.8s ease-out 0.2s both;
        }

        .content-container {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: slideIn 0.6s ease-out 0.4s both;
          position: relative;
          overflow: hidden;
        }

        .content-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
          border-radius: 24px 24px 0 0;
        }

        .page-title {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .title-icon {
          width: 48px;
          height: 48px;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
        }

        .title-text {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1f2937;
        }

        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          color: #6b7280;
        }

        .loading-spinner {
          width: 48px;
          height: 48px;
          border: 4px solid rgba(102, 126, 234, 0.2);
          border-top: 4px solid #667eea;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 1.5rem;
        }

        .loading-text {
          font-size: 1.1rem;
          font-weight: 500;
        }

        .empty-state {
          text-align: center;
          padding: 4rem 2rem;
          color: #6b7280;
        }

        .empty-icon {
          width: 100px;
          height: 100px;
          background: rgba(102, 126, 234, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
          color: #667eea;
        }

        .empty-title {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #374151;
        }

        .empty-description {
          font-size: 1.1rem;
          color: #6b7280;
        }

        .submissions-grid {
          display: grid;
          gap: 1.5rem;
        }

        .submission-card {
          background: white;
          border-radius: 16px;
          padding: 2rem;
          border: 1px solid rgba(229, 231, 235, 0.5);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .submission-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
        }

        .submission-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #667eea, #764ba2);
        }

        .submission-header {
          display: flex;
          justify-content: between;
          align-items: flex-start;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .submission-info {
          flex: 1;
        }

        .assignment-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 0.5rem;
          line-height: 1.4;
        }

        .due-date {
          color: #6b7280;
          font-size: 0.95rem;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .status-badge {
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          white-space: nowrap;
        }

        .submission-details {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .detail-item {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .detail-label {
          font-size: 0.85rem;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .detail-value {
          font-size: 1rem;
          font-weight: 500;
          color: #1f2937;
        }

        .grade-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          border-radius: 12px;
          font-size: 1.2rem;
          font-weight: 800;
          color: white;
        }

        .feedback-section {
          background: rgba(59, 130, 246, 0.05);
          border: 1px solid rgba(59, 130, 246, 0.1);
          border-radius: 12px;
          padding: 1.5rem;
          margin-top: 1.5rem;
        }

        .feedback-label {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          font-weight: 600;
          color: #2563eb;
          margin-bottom: 0.75rem;
        }

        .feedback-text {
          color: #1f2937;
          line-height: 1.6;
          font-size: 0.95rem;
        }

        .view-file-btn {
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 12px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
        }

        .view-file-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        .snackbar {
          position: fixed;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          padding: 1rem 2rem;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          box-shadow: 0 8px 32px rgba(0,0,0,0.3);
          backdrop-filter: blur(10px);
          z-index: 1000;
          animation: slideInFromBottom 0.3s ease-out;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          max-width: 400px;
        }

        .snackbar.success {
          background: rgba(16, 185, 129, 0.9);
        }

        .snackbar.error {
          background: rgba(239, 68, 68, 0.9);
        }

        .snackbar.warning {
          background: rgba(245, 158, 11, 0.9);
        }

        .snackbar.info {
          background: rgba(59, 130, 246, 0.9);
        }

        .snackbar-close {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 4px;
          opacity: 0.8;
        }

        .snackbar-close:hover {
          opacity: 1;
          background: rgba(255, 255, 255, 0.1);
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .submissions-container {
            padding: 1rem 0.5rem;
          }
          
          .content-container {
            padding: 2rem 1.5rem;
          }

          .submission-card {
            padding: 1.5rem;
          }

          .submission-header {
            flex-direction: column;
            align-items: stretch;
          }

          .submission-details {
            grid-template-columns: 1fr;
          }

          .snackbar {
            left: 1rem;
            right: 1rem;
            transform: none;
            max-width: none;
          }
        }

        @media (max-width: 480px) {
          .main-title {
            font-size: 2rem;
          }
          
          .content-container {
            padding: 1.5rem 1rem;
          }
        }
      `}</style>

      <div className="pulse-element"></div>
      
      <div className="submissions-wrapper">
        {/* Header Section */}
        <div className="header-section">
          <div className="header-chip">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
            </svg>
            Student Portal
          </div>
          
          <h1 className="main-title">
            My <span className="gradient-text">Submissions</span>
          </h1>
          
          <p className="subtitle">
            Track your assignment submissions and grades
          </p>
        </div>

        {/* Content Container */}
        <div className="content-container">
          <div className="page-title">
            <div className="title-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19Z"/>
              </svg>
            </div>
            <div className="title-text">Submission History</div>
          </div>

          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <div className="loading-text">Loading your submissions...</div>
            </div>
          ) : submissions.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                </svg>
              </div>
              <div className="empty-title">No Submissions Yet</div>
              <div className="empty-description">
                You haven't submitted any assignments yet. Start by submitting your first assignment!
              </div>
            </div>
          ) : (
            <div className="submissions-grid">
              {submissions.map((submission) => {
                const status = getStatusBadge(submission);
                const gradeColor = getGradeColor(submission.letterGrade);
                
                return (
                  <div key={submission._id} className="submission-card">
                    <div className="submission-header">
                      <div className="submission-info">
                        <div className="assignment-title">
                          {submission.assignmentId?.title || 'Deleted Assignment'}
                        </div>
                        <div className="due-date">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M17,12H12V17H17V12Z"/>
                          </svg>
                          Due: {formatDate(submission.assignmentId?.dueDate)}
                        </div>
                      </div>
                      <div 
                        className="status-badge" 
                        style={{ 
                          color: status.color, 
                          backgroundColor: status.bg 
                        }}
                      >
                        {status.text}
                      </div>
                    </div>

                    <div className="submission-details">
                      <div className="detail-item">
                        <div className="detail-label">Submission File</div>
                        <div className="detail-value">
                          {submission.fileUrl ? (
                            <button
                              className="view-file-btn"
                              onClick={() => window.open(submission.fileUrl, '_blank')}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"/>
                              </svg>
                              View File
                            </button>
                          ) : (
                            <span style={{ color: '#6b7280' }}>No file available</span>
                          )}
                        </div>
                      </div>

                      <div className="detail-item">
                        <div className="detail-label">Grade</div>
                        <div className="detail-value">
                          {submission.letterGrade ? (
                            <div 
                              className="grade-badge" 
                              style={{ backgroundColor: gradeColor }}
                            >
                              {submission.letterGrade}
                            </div>
                          ) : (
                            <span style={{ color: '#6b7280' }}>Not graded yet</span>
                          )}
                        </div>
                      </div>
                    </div>

                    {submission.feedback && (
                      <div className="feedback-section">
                        <div className="feedback-label">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M20,16H6L4,18V4H20V16Z"/>
                          </svg>
                          Instructor Feedback
                        </div>
                        <div className="feedback-text">{submission.feedback}</div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Snackbar Notification */}
      {snackbar.open && (
        <div className={`snackbar ${snackbar.severity}`}>
          <span>{snackbar.message}</span>
          <button className="snackbar-close" onClick={closeSnackbar}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default StudentSubmissions;